import { render, staticRenderFns } from "./BiddingAward.vue?vue&type=template&id=58825dcc"
import script from "./BiddingAward.vue?vue&type=script&lang=js"
export * from "./BiddingAward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports